import React from 'react'
import { Card } from 'semantic-ui-react'

const Sertifikat = () => (
    <Card

        header='EFSET Quick English Check - Score:'
        meta='Intermediate / Upper Intermediate(CEFR B1/B2)'
        href='https://www.linkedin.com/in/herka-trya-fitra-4aa117133'
        target='_blank'
    />
)

export default Sertifikat
